import { Component, OnInit, Input } from '@angular/core';
import * as _ from 'lodash';
@Component({
  selector: 'panelP',
  templateUrl: './panelP.component.html',
  styleUrls: ['./panelP.component.scss']
})
export class PanelPComponent implements OnInit {
  @Input() table;
  @Input() parentTable;

  @Input() popover;

  showPopover($event) {

    this.popover.show($event);
  }
  duplicateField(field) {
    // let newField = Object.assign({}, field);
    let newField = _.cloneDeep(field);
    this.parentTable.push(newField);

  }

  constructor() { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/module/project/panelP/panelP.component.ts